<template>
  <div class="header-container">
    <span class="header-text">{{ headerText }}</span>
    <button
      type="button"
      :class="`icon-close`"
      data-dismiss="modal"
      aria-label="Close"
      @click="closeModal"
    >
      <img src="@/assets/img/small-close.svg" />
    </button>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({})
export default class HeaderModal extends Vue {
  @Prop({ required: true })
  public headerText!: string;

  closeModal() {
    this.$emit("closeModal");
  }
}
</script>

<style scoped>
.header-text {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #211f58;
}
.header-container {
  padding: 20px 40px;
}
.icon-close {
  padding: 0;
  background-color: transparent;
  border: 0;
  color: #000;
  float: right;
}
</style>
